exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-row[data-v-595e0a50]:not(:last-child) {\n  background-color: #ffffff;\n  border: solid 1px #bfbfbf;\n  border-bottom: none;\n}", ""]);

// exports
